/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { createAsyncThunk } from "@reduxjs/toolkit";
import { AdasProgram } from "./types";
import { config } from "../../../AppConfig/config";
import ADAS_PROGRAMS_CONSTANTS from "../../../containers/pages/AdasPrograms/constants";


/** Fetches all ADAS Programs */
export const fetchAdasPrograms = createAsyncThunk('adasPrograms/fetchAdasPrograms', async (idToken: string) => {
  const fetchAdasProgramsUrl = `${config.url.API_URL}${ADAS_PROGRAMS_CONSTANTS.landingPage.fetchPrograms}`
  const response = await fetch(fetchAdasProgramsUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`
    },
  })
  if (!response.ok) {
    throw new Error('Failed to fetch ADAS Programs')
  }
  return (await response.json()) as AdasProgram[]
})
